import appConfig from '../../configs/appConfig';
import awsRumCustomActions from '../../consts/aws/awsRumCustomActions';
import {ecUwmModuleSelfNames, uwmEntries} from '../../consts/uwm/uwmEntries';
import ecCycleService from './ecCycleService';
import ecFlowService from './ecFlowService';
import ecPushRegistry from './ecPushRegistry';

const EC_UWM_ENTRIES = [uwmEntries.EXPERIENCE_COACH_ORION, uwmEntries.INSIGHTS_ORION, uwmEntries.FEEDBACK_ORION];

const ecHostActions = Object.values(awsRumCustomActions);

const withFlowId = () => {
    const ecFlowId = ecFlowService.getFlowId();

    return ecFlowId ? {ecFlowId} : {};
};

const isEcModule = (moduleName) =>
    Boolean(moduleName) &&
    (ecUwmModuleSelfNames.includes(moduleName) ||
        EC_UWM_ENTRIES.some((entry) => appConfig.getUwmModuleName(entry) === moduleName));

const getUwmKeys = ({moduleName, action, recommendationType} = {}) => {
    if (!isEcModule(moduleName)) return {};

    return {
        ...withFlowId(),
        ...ecCycleService.resolve(recommendationType, action),
    };
};

const getHostActionKeys = (action, recommendationType) =>
    ecHostActions.includes(action) ? {...withFlowId(), ...ecCycleService.resolve(recommendationType, action)} : {};

const getNotificationKeys = (notificationSubType) =>
    ecPushRegistry.isEcSubType(notificationSubType) ? withFlowId() : {};

export default {
    getUwmKeys,
    getHostActionKeys,
    getNotificationKeys,
};
